<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
        <div class="filters-container flex flex-wrap items-center justify-start">
          <div class="form-group has-search ml-3 my-3 position-relative">
          <label class="vs-input--label">START DATE</label>
          <div>
            <flat-pickr
              class="w-100"
              :config="{
                  ...configdateTimePicker,
                  dateFormat:  'm-d-Y H:i:s',
                  defaultDate: new Date().setHours(0, 0, 0),
                }"
              v-model="start_time"
              @input="SetDatetimeForStart"
            />
          </div>
        </div>
          <div class="form-group has-search ml-3 my-3 position-relative">
          <label class="vs-input--label">END DATE</label>
          <div>
            <flat-pickr
              class="w-100"
              :config="{
                ...configdateTimePicker,
                  dateFormat:  'm-d-Y H:i:s',
                  defaultDate: new Date().setHours(23, 59, 59),
                }"
              v-model="end_time"
              @input="SetDatetimeForEnd"
            />
          </div>
        </div>

        <!--          <div class="md:mb-5 ml-6">
                    <label class="vs-input&#45;&#45;label">Caller ID</label>
                      <vs-input/>
                  </div>
                  <div class="md:mb-5 ml-6">
                    <label class="vs-input&#45;&#45;label">Destination Number</label>
                      <vs-input/>
                  </div>-->
          <div class="form-group has-search ml-3 my-3 position-relative">
          <label class="vs-input--label">Step</label>
          <v-select
            name="step"
            label="name"
            placeholder="Select All Day or Daily"
            v-model="step"
            :options="steps"
          />
        </div>
        </div>
       <!-- <div class="smsc-navigation__col ml-6 mt-6">
          <vs-button @click="GetList1">Sent</vs-button>
        </div>-->
        <!--          <div class=" md:mb-4 ml-6 ">
                    <label class="vs-input&#45;&#45;label">Ani</label>
                    <v-select
                      multiple
                      class="filter-select"
                      :options="step"
                      v-model="step"
                      @input="getValue"
                      label="name"
                    />
                  </div>-->
      </div>
    </vx-card>
    <vx-card>
      <!-- Per Page -->
      <div class="mb-4 md:mb-0" >
        <per-page
          :currentPerPage="per_page"
          :pageStart="pageStart"
          :pageEnd="pageEnd"
          :total="total"
          @change-per-page="ChangePerPage($event)"
        />
      </div>

      <!-- Table -->
      <ag-grid-vue
        :components="components"
        :gridOptions="gridOptions"
        :class="{'noDataTable': !list.length}"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="list"
        @gridReady="GridReady"
        @filterChanged="Filtering"

        :animateRows="true"
        :floatingFilter="isFloatingFilter"
        :pagination="true"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      >
      </ag-grid-vue>

      <!-- Pagination -->
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="Page" />
    </vx-card>
  </div>
</template>

<script>
  // Mixins
  import TableMixin from '@/mixins/table.js'
  import DateTimeMixin from '@/mixins/datetime.js'

  // Packages
  import vSelect from 'vue-select'
  import { AgGridVue } from 'ag-grid-vue'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  export default {
    mixins: [TableMixin, DateTimeMixin],
    components: {
      AgGridVue,
      flatPickr,
      vSelect,

      // CellRendererLink,
      // CellRendererStatus,
      // CellRendererVerified,
      // CellRendererActions,
    },
    data() {
      return {
        start_time:  new Date().setHours(0, 0, 0),
        end_time:  new Date().setHours(23, 59, 59),
        steps:[],
        stepsValue:'day',
        step: {
          name:"Daily",
          value:"day"
        },
        // table header value

        defaultColDef: {
          enableRowGroup: true,
          enablePivot: true,
          enableValue: true,
          width: 100,
          sortable: true,
          resizable: true,
          filter: true,
          flex: 1,
          minWidth: 100,
        },
        columnDefs: [
          {
            headerName: 'Data',
            field: 'sms_time',
              minWidth: 260,
          },
          {
            headerName: 'Incoming SMS',
           /* children: [
              { field: 'Count', filter: 'count', minWidth: 200 },


            ],*/
              minWidth: 120
          },
          {
            headerName: 'Outgoing SMS',
            // minWidth: 800,
            style:'margin-left:200px',
           /* children: [
              { field: 'Count', filter: 'Count', minWidth: 200 },
              { field: 'Sent', filter: 'sent', minWidth: 200 },
              { field: 'Error', filter: 'error', minWidth: 200 },
              { field: 'Cost', filter: 'cost', minWidth: 200 },

            ],*/
            //   minWidth: 120
          },

        ],

        // Cell Renderer components
        components: {
          //     CellRendererActions,
          //     CellRendererStatus
        },
        //   searchProduct: ''
      }
    },
    created() {
      this.filters.end_time = parseInt((new Date(this.end_time).getTime()/1000))
      this.filters.start_time = parseInt((new Date(this.start_time).getTime()/1000))
      this.steps=[
        {
          name: 'All Day',
          value: 'all day',
        },
        {
          name: 'Daily',
          value: 'day',
        }
      ]
    },
    methods: {
      // inputStepValue(value) {
      //   this.stepsValue = value.value;
      //
      // },
      SetDatetimeForStart(e) {
        this.filters.start_time =  parseInt((new Date(this.start_time).getTime()/1000))
      },
      SetDatetimeForEnd(e){
        this.filters.end_time = parseInt((new Date(this.end_time).getTime()/1000))
      },
      GetList1() {

        this.$vs.loading()
        this.$store.dispatch('log/GetListForCompanyAdmin', {
          ...this.filters,
          from: this.page || 0,
          count: this.per_page || 10,
          step: this.step ? this.step.value : '' ,
        })
          .then(res => {
            this.list = res.data.map(this.TransformReseller)
            this.total = res.total
          })
          .catch()
          .finally(() => {
            this.$vs.loading.close()
          })
      },

      TransformReseller(item) {
        console.log(item)
        return {
          ...item,
          refreshData: this.GetList1,
          sms_time: format(new Date(item.sms_time * 1000), 'yyyy-dd-MM HH:mm:ss'),
        }
      },
      onQuickFilterChanged() {
        this.GetList1()
      },
    }
  }
</script>
<style>
  #select{

  }
  .filter_input_reseller{
    padding: 17px;
    padding-left: 55px;
    width: 300px;
    border: 1px solid #f5f5f5;
    font-size: 13px;
    color: gray;
    background-repeat: no-repeat;
    background-position: left center;
    outline: 0;
  }
  .has-search .form-control-reseller-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 15px;
    height: 15px;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: gray;
    margin-left: 35px;
    margin-top: 20px;
  }
  .sent-btn {
    margin-right: auto!important;
    padding-top: 10px;
  }

</style>
<style scoped>
  .filter_input_company{
    padding: 17px;
    padding-left: 55px;
    width: 220px;
    height: 41px;
    border: 1px solid #f5f5f5;
    font-size: 13px;
    color: gray;
    background-repeat: no-repeat;
    background-position: left center;
    outline: 0;
  }
  .has-search .form-control-company-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 15px;
    height: 15px;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: gray;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
  }
</style>
<style scoped lang="scss">
  .did-container {
    padding: 0;
    margin-top: 20px;
    .content {
      height: fit-content;
      .nav-header {
        height: 50px;
        background-color: #fff;
        padding: 0px 15px 0px 15px;
        display: flex;
        p {
          cursor: pointer;
          height: 100%;
          display: flex;
          align-items: center;
          padding: 0px 5px 0px 5px;
          color: #bdbfd8;
          font-family: ""Helvetica Neue"";
          font-size: 16px;
          font-weight: 500;
          line-height: 20px;
          text-align: center;
          margin-right: 10px;
          margin-bottom: 0;
        }
        .active {
          color: #51a3f3;
          border-bottom: 2px solid #51a3f3;
        }
      }
    }

    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      margin-top: 20px;
      .secondary-but.ton {
        height: 40px;
        width: 90px;
        margin-right: 15px;
      }
    }
  }
</style>




